import React, { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

const NewsletterView = lazy(() => import('../../container/crud/newsletter/Index'));
const NewsletterAdd = lazy(() => import('../../container/crud/newsletter/Add'));


const PagesRoute = () => {
  const { path } = useRouteMatch();
  //<Route path={`${path}/dataTable`} component={DataTable} />
  return (
    <Switch>
      <Route path={`${path}/view`} component={NewsletterView} />
      <Route path={`${path}/add`} component={NewsletterAdd} />
      <Route exact path={`${path}/edit/:id`} component={NewsletterAdd} />
    </Switch>
  );
};

export default PagesRoute;
